import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.background.paper};
  border-top: 1px solid ${({ theme }) => theme.colors.border.medium};
  padding: ${({ theme }) => theme.spacing.md};
  height: 60px;
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 90;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  padding: 8px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <IconButton>←</IconButton>
      <IconButton>→</IconButton>
      <IconButton>⏸</IconButton>
      <IconButton>⏹</IconButton>
    </FooterContainer>
  );
};

export default Footer; 